import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    const baseUrl = '/login/';
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { name: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string }) {
    const baseUrl = '/reset_password/';
    return api.create(`${baseUrl}`, params);
}

function user_check(params: { email: string; otp:string }) {
    const baseUrl = '/user_check/';
    return api.create(`${baseUrl}`, params);
}


function resend_otp(params: { email: string; }) {
    const baseUrl = '/resend_otp/';
    return api.create(`${baseUrl}`, params);
}
function verifyOtp( email: string, otp: string ) {
    const baseUrl = '/user_check/';
    return api.create(`${baseUrl}`, {email,otp});
    
}
function verifyPasswordOtp( email: string, otp: string ) {
    const baseUrl = '/reset_password_checked/';
    return api.create(`${baseUrl}`, {email,otp});
    
}
function resetPassword(email: string, password: string) {
    const baseUrl = '/update_otp_password/';
    return api.create(baseUrl, { email, password });
}



export { verifyPasswordOtp, resetPassword,login, logout, signup, forgotPassword, user_check, resend_otp, verifyOtp };
